module.exports = __webpack_public_path__ + "img/shared-by-you-profile.9c8b1b3c.svg";